import { render, staticRenderFns } from "./MessageInactive.vue?vue&type=template&id=4175856b"
import script from "./MessageInactive.vue?vue&type=script&lang=js"
export * from "./MessageInactive.vue?vue&type=script&lang=js"
import style0 from "./MessageInactive.vue?vue&type=style&index=0&id=4175856b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports